<div class="callback-container" data-testid="callback-container">
  <p class="callback-message">Processing authentication&hellip;</p>
</div>
